module.exports = __webpack_public_path__ + "static/media/Crouch End Alcoves 6.2e3da7ec.jpg";